export const colors = {
    darkblue: '#1D3C8A',
    darkblue90: 'rgba(29, 60, 138, 0.9)',
    darkblue20: 'rgba(29, 60, 138, 0.2)',
    lightblue: '#3FA2F7',
    yellow: '#FFD151',
    line: '#E9ECF4',
    success: '#6CE2E3',
    failed: '#FB7B55'
};